"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIAssistApiHelper = void 0;
const translations_1 = require("@front/application/globals/translations");
/**
 * Static helper class for AI Assistant API operations
 */
class AIAssistApiHelper {
    /**
     * Create assist request from text and context
     */
    static createAssistRequest(text, context, excludeKnowledgeIds) {
        return {
            text: text,
            language: (0, translations_1.getLanguage)(),
            context: context,
            excludeKnowledgeIds: (excludeKnowledgeIds === null || excludeKnowledgeIds === void 0 ? void 0 : excludeKnowledgeIds.length) ? excludeKnowledgeIds : undefined
        };
    }
    /**
     * Make assist API call
     */
    static async callAssist(apiService, request) {
        try {
            const response = await apiService.back.post('ai.assist', request);
            // Immediately return response regardless of success to stop thinking state
            if (response.success && response.data) {
                return response.data;
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;
        }
    }
    /**
     * Convert messages to IFrontChatMessage format
     */
    static convertMessageToFrontChatMessage(messages) {
        return messages.map(msg => ({
            content: msg.content,
            role: msg.role,
            files: msg.files
        }));
    }
    /**
     * Get last user message from context
     */
    static getLastUserMessage(context) {
        return context
            .slice()
            .reverse()
            .find(msg => msg.role === 'user') || null;
    }
    /**
     * Get recent conversation context
     */
    static getRecentConversationText(context, messageCount = 4) {
        const recentMessages = context.slice(-messageCount);
        return recentMessages
            .map(msg => `${msg.role}: ${msg.content}`)
            .join('\n');
    }
    /**
     * Validate text for analysis
     */
    static isTextValidForAnalysis(text, minLength = 20) {
        return text && text.trim().length >= minLength;
    }
}
exports.AIAssistApiHelper = AIAssistApiHelper;
